import { ButtonIcon, Flex, LinkOverlay, Text } from 'front-end/src/components'
import { NavigationWorkspaceItem } from 'front-end/src/components/navigation/NavigationWorkspaceItem'
import React, { useState } from 'react'
import { t } from '@lingui/macro'
import { linkBuilder } from 'shared/linkBuilder'
import IconSubsection from 'front-end/src/components/common/icon/IconSubsection'
import { IconMinus2 } from '../common/icon/IconMinus2'
import { IconPlus } from 'front-end/src/components/common/icon/IconPlus'
import { NavigationWorkspaceAnimation } from 'front-end/src/components/navigation/NavigationWorkspaceAnimation'

export const NavigationWorkspaceItemWithThemes = ({
  workspace,
  hideNavigation
}) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <>
      <NavigationWorkspaceItem
        workspace={workspace}
        hideNavigation={hideNavigation}
      >
        <ButtonIcon
          aria-label={isExpanded ? t`Hide themes` : t`Show themes`}
          circular
          size="sm"
          onClick={() => setIsExpanded(!isExpanded)}
          icon={
            isExpanded ? (
              <IconMinus2 boxSize="16px" />
            ) : (
              <IconPlus boxSize="16px" />
            )
          }
          _focus={{
            boxShadow: 'none'
          }}
        />
      </NavigationWorkspaceItem>
      <NavigationWorkspaceAnimation isExpanded={isExpanded}>
        {workspace.themes
          .filter((theme) => theme.topicsCount > 0)
          .map((theme) => (
            <Flex
              key={theme.id}
              className="Navigation__link__wrapper"
              pl="26px"
            >
              <LinkOverlay
                className="Navigation__link"
                to={linkBuilder.workspaceUrl(workspace.id, theme.id)}
                onClick={() => {
                  hideNavigation()
                  document
                    .getElementById(theme.id)
                    ?.scrollIntoView({ behavior: 'smooth' })
                }}
                title={workspace.name}
              >
                <IconSubsection />
                <Text flex={1} noOfLines={2}>
                  {theme.title}
                </Text>
              </LinkOverlay>
            </Flex>
          ))}
      </NavigationWorkspaceAnimation>
    </>
  )
}
